<template>
  <Infomation :item="miniNews" heading="お知らせ" />
  <div class="home">
    <HomeMainVisual />
    <template v-if="!isLogin">
      <div class="eventArea">
        <EventBanner />
      </div>
      <div class="hiddenPc u-containar" style="margin: 30px 0 40px">
        <HomeEasySearch
          :count="hospitalCount"
          @click-btn="openEasySearchModal"
        />
      </div>
    </template>

    <div class="homeMiddleContents">
      <div class="homeMiddleContents_event">
        <JoinMyFes :navigation="['pc']" />
      </div>

      <!-- <div class="homeMiddleContents_bnr u-containar">
        <router-link to="/lp/etc/taimen-events">
          <picture>
            <source
              media="(max-width: 899px)"
              srcset="@/assets/images/home/taimen2023_sp.png"
            />
            <img
              src="@/assets/images/home/taimen2023_pc.png"
              alt="予約受付中 対面型合同説明会 2.12-6.10全国開催！ 詳しく見る"
            />
          </picture>
        </router-link>
      </div> -->

      <div class="homeMiddleContents_specialFeature">
        <SpecialFeatureCardSlider :items="topSpecialFeatures" />
      </div>

      <div class="homeMiddleContents_ad" v-if="adBanners[0]">
        <HomeAdBanner :banner="adBanners[0]" />
      </div>

      <div class="homeMiddleContents_search u-containar" v-if="!isLogin">
        <HeadingLv2 text="研修病院を探す" icon="hospital" />
        <div class="homeSearch">
          <div class="homeSearch_item hiddenSp">
            <HomeEasySearch
              :count="hospitalCount"
              @click-btn="openEasySearchModal"
            />
          </div>
          <div class="homeSearch_item">
            <HomeMapSearch />
          </div>
        </div>
      </div>
    </div>

    <section class="homeSection u-containar" v-if="pickupHospitals.length > 0">
      <HeadingLv2 text="全国のピックアップ病院" icon="national" />

      <ul class="hospitalsDetailAside_list">
        <HomeHospitalCassette
          class="hospitalsDetailAside_listItem"
          v-for="(hospital, i) in pickupHospitals"
          :key="i"
          :hospital="hospital"
          narrow
        />
      </ul>
    </section>

    <section
      class="homeSection u-containar"
      v-if="recommendedHospitals.length > 0"
    >
      <HeadingLv2
        v-if="isLogin"
        :text="`${userInfo.name}さん、おすすめ研修先病院`"
        icon="hospital"
      />
      <HeadingLv3 v-if="!isLogin" text="人気上昇中の研修病院" />

      <ul class="hospitalsDetailAside_list">
        <HomeHospitalCassette
          class="hospitalsDetailAside_listItem"
          v-for="(hospital, i) in recommendedHospitals"
          :key="i"
          :hospital="hospital"
          narrow
        />
      </ul>

      <Button
        href="/search/hospital/list"
        :handleClick="
          () => {
            $router.push(`/search/hospital/list`)
          }
        "
        label="もっと見る"
        primary
      />
    </section>

    <div class="homeAdBanner" v-if="adBanners[1]">
      <HomeAdBanner :banner="adBanners[1]" />
    </div>

    <HomeRecommendSpecial
      class="homeSection u-containar"
      :contents="specialRecommendContents"
    />

    <HomeRecommendSeries
      class="homeSection u-containar"
      :contents="seriesTopContents"
    />

    <HomeNews class="homeSection" />
  </div>
  <LogoutModal :visivle="state.logoutModal" @close="closeLogoutModal" />
  <HomeEasySearchModal ref="easySearchModalRef" />
  <AdArea />
</template>

<script lang="ts">
import { ref, reactive, defineComponent, computed, onMounted } from 'vue'
import { useStore } from 'vuex'
import Infomation from '@/components/block/Infomation.vue'
import HomeMainVisual from '@/components/block/HomeMainVisual.vue'
import EventBanner from '@/components/block/EventBanner.vue'
import HomeMapSearch from '@/components/block/HomeMapSearch.vue'
import HomeEasySearch from '@/components/block/HomeEasySearch.vue'
import HomeEasySearchModal from '@/components/block/HomeEasySearchModal.vue'
import HeadingLv2 from '@/components/elements/HeadingLv2.vue'
import HeadingLv3 from '@/components/elements/HeadingLv3.vue'
import HomeHospitalCassette from '@/components/block/HomeHospitalCassette.vue'
import Button from '@/components/elements/Button.vue'
import HomeRecommendSpecial from '@/components/block/HomeRecommendSpecial.vue'
import HomeRecommendSeries from '@/components/block/HomeRecommnedSeries.vue'
import JoinMyFes from '@/components/block/JoinMyFes.vue'
import SpecialFeatureCardSlider from '@/components/block/SpecialFeatureCardSlider.vue'
import HomeNews from '@/components/block/HomeNews.vue'
import LogoutModal from '@/components/genenral/ModalLogout.vue'
import AdArea from '@/components/block/AdArea.vue'
import HomeAdBanner from '@/components/block/HomeAdBanner.vue'
import { useAdBanners } from '@/provider/adBanners'
import { useRecommend } from '@/provider/recommend'
import { useSpecial } from '@/provider/special'
import { useTopSpecialFeatures } from '@/provider/topSpecialFeatures'

export default defineComponent({
  name: 'Home',

  components: {
    Infomation,
    HomeMainVisual,
    EventBanner,
    HomeMapSearch,
    HomeEasySearch,
    HomeEasySearchModal,
    HeadingLv2,
    HeadingLv3,
    HomeHospitalCassette,
    HomeRecommendSpecial,
    HomeRecommendSeries,
    JoinMyFes,
    SpecialFeatureCardSlider,
    HomeNews,
    AdArea,
    HomeAdBanner,
    LogoutModal,
    Button
  },

  setup() {
    const store = useStore()

    // top 注目の記事取得
    const {
      topSpecialFeatures,
      loadTopSpecialFeatures
    } = useTopSpecialFeatures()

    // レコメンド記事取得
    const {
      loadRecommends,
      getHomeSpecialRecommends,
      getHomeSeriesTopRecommends
    } = useRecommend()

    // 連載記事取得
    const { loadContents, getSeriesSpecialContents } = useSpecial()

    // バナー取得
    const { loadAdBanners, getRandomAdBanners } = useAdBanners()

    const state = reactive<any>({
      logoutModal: false
    })

    const easySearchModalRef = ref()

    const openEasySearchModal = (type: string) => {
      easySearchModalRef.value.easySearchModal.open(type)
    }

    const showLogoutModal = () => {
      store.commit('fixBody')
      state.logoutModal = true
      document.cookie = 'logout=; max-age=0'
    }

    const closeLogoutModal = () => {
      store.commit('unFixBody')
      state.logoutModal = false
    }

    // TODO: クッキー関連の処理を外部化したい
    // ログアウトモーダルの制御
    const cookieLogout = document.cookie
      .split('; ')
      .find((row) => row.startsWith('logout'))

    if (cookieLogout && cookieLogout.split('=')[1] === '1') {
      showLogoutModal()
    }

    onMounted(() => {
      store.dispatch('home/loadHospitalCount')
      store.dispatch('home/loadMiniNews')
      store.dispatch('home/loadNews')
      store.dispatch('home/loadEvents')
      store.dispatch('home/loadPickupHospitals')

      loadTopSpecialFeatures()
      loadRecommends()
      loadContents({ parentCategory: 'series', orderBy: 'modified' })
      loadAdBanners({ optId: 2 })

      if (store.state.isLogin) {
        store.dispatch('home/loadRecommendedHospitals')
      } else {
        // TODO: クッキー関連の処理を外部化したい
        // クッキーにTOPでエリアを検索したデータがあれば実行
        const cookieSearchAreaHome = document.cookie
          .split('; ')
          .find((row) => row.startsWith('searchAreaHome'))

        if (cookieSearchAreaHome) {
          const areaId = cookieSearchAreaHome.split('=')[1]

          store.dispatch('home/loadRecommendedHospitals', { areaId })
        }
      }
    })

    return {
      isLogin: computed(() => store.state.isLogin),
      userInfo: computed(() => store.state.userInfo),
      adBanners: computed(() => getRandomAdBanners(2)),
      hospitalCount: computed(() => store.state.home.hospitalCount),
      miniNews: computed(() => store.state.home.miniNews),
      specialRecommendContents: computed(() => getHomeSpecialRecommends()),
      seriesTopContents: computed(() => [
        ...getHomeSeriesTopRecommends(),
        ...getSeriesSpecialContents()
      ]),
      pickupHospitals: computed(
        () => store.getters['home/getEnrichedPickupHospitals']
      ),
      recommendedHospitals: computed(
        () => store.getters['home/getEnrichedRecommendedHospitals']
      ),
      state,
      openEasySearchModal,
      easySearchModalRef,
      topSpecialFeatures,
      closeLogoutModal
    }
  }
})
</script>

<style lang="scss" scoped>
@use 'src/styles/abstracts/mixins';
@use 'src/styles/abstracts/variables' as var;

.eventArea {
  @include mixins.mediaMax() {
    background-color: #e7f8f6;
    padding: 30px 16px 40px;
  }

  @include mixins.media() {
    padding: 55px 20px 90px;
  }
}

.homeSection {
  margin-top: 48px;
  margin-bottom: 48px;

  @include mixins.media('sm') {
    margin-top: 72px;
    margin-bottom: 72px;
  }

  @include mixins.media() {
    margin-top: 96px;
    margin-bottom: 96px;
  }
}

.homeMiddleContents_ad {
  padding: 0 16px;

  @include mixins.media() {
    padding: 0 20px;
  }
}

@include mixins.media() {
  .homeMiddleContents {
    display: flex;
    flex-direction: column;

    &_event {
      order: 2;
      width: 100%;
    }

    &_specialFeature {
      order: 4;
      width: 100%;
    }

    &_search {
      order: 1;
      width: 100%;
    }

    &_ad {
      order: 5;
      margin-top: 48px;
      margin-bottom: -28px;
    }
  }

  .homeMiddleContents_ad + .homeMiddleContents_search,
  .homeMiddleContents_event + .homeMiddleContents_search,
  .homeMiddleContents_specialFeature + .homeMiddleContents_search {
    margin-bottom: 96px;
  }
  .homeMiddleContents_bnr {
    margin-top: 48px;
    order: 3;
  }
}

@include mixins.mediaMax() {
  .homeMiddleContents_ad,
  .homeMiddleContents_event,
  .homeMiddleContents_specialFeature {
    margin-bottom: 48px;
  }
  .homeMiddleContents_bnr {
    margin-top: 0;
    margin-bottom: 64px;
  }
}

.homeSearch {
  margin-top: 20px;
  @include mixins.media() {
    display: flex;
    justify-content: space-between;
    align-items: flex-end;

    &_item {
      flex: 0 0 calc((100% - 40px) / 2);
    }
  }
}

// @TODO 病院詳細ページで同じものを使っているので共通化したい
.hospitalsDetailAside_list {
  margin-bottom: 30px;

  @include mixins.media() {
    display: flex;
    flex-wrap: wrap;
    align-items: flex-start;
  }
}

.hospitalsDetailAside_listItem {
  margin-top: 16px;

  @include mixins.media() {
    flex-basis: calc(50% - 20px);
    max-width: calc(50% - 20px);
    margin-top: 24px;

    &:nth-child(even) {
      margin-left: auto;
    }
  }
}

.homeAdBanner {
  margin-top: -10px;
  margin-bottom: -10px;
  padding: 0 16px;

  @include mixins.media() {
    margin-top: -18px;
    margin-bottom: -24px;
    padding: 0 20px;
  }
}

.homeMiddleContents + .homeAdBanner {
  @include mixins.media() {
    margin-top: 70px;
  }
}
</style>
